"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const React = require("react");
const utilities_css = require("../utilities/css.js");
const Text$1 = "_Text_3z6g3_5";
const heading1 = "_heading1_3z6g3_13";
const heading2 = "_heading2_3z6g3_30";
const heading3 = "_heading3_3z6g3_47";
const heading4 = "_heading4_3z6g3_64";
const heading5 = "_heading5_3z6g3_72";
const subtitle1 = "_subtitle1_3z6g3_80";
const subtitle2 = "_subtitle2_3z6g3_88";
const body1 = "_body1_3z6g3_96";
const body2 = "_body2_3z6g3_104";
const caption = "_caption_3z6g3_112";
const overline = "_overline_3z6g3_120";
const button = "_button_3z6g3_128";
const normal = "_normal_3z6g3_144";
const medium = "_medium_3z6g3_148";
const semibold = "_semibold_3z6g3_152";
const bold = "_bold_3z6g3_156";
const truncate = "_truncate_3z6g3_160";
const block = "_block_3z6g3_166";
const visuallyHidden = "_visuallyHidden_3z6g3_170";
const start = "_start_3z6g3_183";
const center = "_center_3z6g3_187";
const end = "_end_3z6g3_191";
const justify = "_justify_3z6g3_195";
const numeric = "_numeric_3z6g3_203";
const transformNone = "_transformNone_3z6g3_207";
const transformCapitalize = "_transformCapitalize_3z6g3_211";
const transformUppercase = "_transformUppercase_3z6g3_215";
const transformLowercase = "_transformLowercase_3z6g3_219";
const styles = {
  Text: Text$1,
  heading1,
  heading2,
  heading3,
  heading4,
  heading5,
  subtitle1,
  subtitle2,
  body1,
  body2,
  caption,
  overline,
  button,
  "small-button": "_small-button_3z6g3_136",
  normal,
  medium,
  semibold,
  bold,
  truncate,
  block,
  visuallyHidden,
  start,
  center,
  end,
  justify,
  "break": "_break_3z6g3_199",
  numeric,
  transformNone,
  transformCapitalize,
  transformUppercase,
  transformLowercase
};
function Text({ alignment, as: Component = "span", breakWord = false, children, color, id, transform = "none", truncate: truncate2 = false, variant, visuallyHidden: visuallyHidden2 = false, weight }) {
  const className = utilities_css.classNames(styles.Text, variant && styles[cleanVariant(variant)], weight && styles[weight], (alignment || truncate2) && styles.block, alignment && styles[alignment], breakWord && styles.break, truncate2 && styles.truncate, visuallyHidden2 && styles.visuallyHidden, transform && styles[utilities_css.variationName("transform", transform)]);
  const style = __spreadValues({}, utilities_css.getComponentThemeToken("text", "color", "color.text", color));
  return React.createElement(Component, {
    className,
    style,
    id: id ? id : void 0
  }, children);
}
function cleanVariant(variant) {
  return variant.replace(/_/, "-");
}
exports.Text = Text;
